import { ErrorReason } from '@/types';

export const errorReasonMap = {
  [ErrorReason.GENERATION_FAILURE]: 'Bundle generation failed in Athena.',
  [ErrorReason.NOT_EXISTS]: 'Bundle to download no longer exists in Athena.',
  [ErrorReason.GENERATION_NOT_STARTED]:
    'Bundle generation process in Athena did not start.',
  [ErrorReason.DOWNLOAD_FAILURE]: 'Download of the bundle from Athena failed.',
  [ErrorReason.API_COMMUNICATION_ERROR]: 'Communication error with Athena.',
  [ErrorReason.INTERNAL_ERROR]: 'Internal error.',
};
